import { useFela } from 'react-fela';
import React from 'react';
import PropTypes from 'prop-types';

const rules = (({ theme, barWidth, brand }) => ({
  background: `${brand ? theme.color.brand : theme.color.playerProgressTrack}`,
  borderRadius: '2px',
  height: '8px',
  width: `${barWidth}px`,
  left: '10px',
  position: 'absolute',
  top: '11px',
  ':hover': {
    opacity: '1',
  },

}));

const Track = ({ barWidth, brand }) => {
  const { css } = useFela({ barWidth, brand });

  return (
    <div className={css(rules)} />
  );
};

Track.propTypes = {
  barWidth: PropTypes.number.isRequired,
  brand: PropTypes.bool,
};

export default React.memo(Track);
